import {getFullContent as getFullContentRequest} from '@api/preview';
import Preview from '@components/Preview';
import SubscriptionForm from '@components/Preview/SubscriberPreview/SubscriptionForm';
import type {GetFullContentResponse} from '@interfaces/PreviewWidget';
import type {ReactElement} from 'react';
import I18n from '@components/I18n';

interface Props {
    code: string;
    title: string;
}

export default function PreviewWidget(props: Props): ReactElement<Props> {
    async function getFullContent(): Promise<GetFullContentResponse> {
        return getFullContentRequest({code: props.code});
    }

    return (
        <Preview getFullContent={getFullContent}>
            {afterContentRetrieved => (
                <div className="subscriber-preview">
                    <h2 className="subscriber-preview__title">{props.title}</h2>
                    <div className="subscriber-preview__content">
                        <div className="subscriber-preview__details">
                            <I18n code="Preview_subscribePreview" />
                        </div>
                        <SubscriptionForm code={props.code} onSubmit={afterContentRetrieved} />
                    </div>
                </div>
            )}
        </Preview>
    );
}
